import { getSuggestions } from '../api/index'

const actions = {
  async getSuggestions ({ commit }: any, { params }: any) {
    try {
      console.log('actions params', params)
      const res = await getSuggestions(params)
      // console.log(res)
    } catch (error) {
      throw new Error(error)
    }
  }
}

export default actions
